import { calculateFrameEdges } from '../../../lib/framingDimensions'

const FrameBorder = ({ id, frame, dimensions, texture, children }) => {
  const edges = calculateFrameEdges(dimensions).filter((edge) => edge.width > 0)
  return (
    <>
      <defs>
        {edges.map((edge) => (
          <clipPath
            key={edge.side}
            id={`${id}-${edge.side}-clip`}
            clipPathUnits="userSpaceOnUse"
          >
            <polygon points={edge.points} />
          </clipPath>
        ))}
        {edges.map((edge) => {
          const tileLength = (edge.width * texture.height) / texture.width
          const tileOverlap = edge.width / texture.width
          return (
            <pattern
              key={edge.side}
              id={`${id}-${edge.side}-texture`}
              patternUnits="userSpaceOnUse"
              patternContentUnits="userSpaceOnUse"
              width={edge.width}
              height={tileLength}
            >
              <image
                href={frame.assetUrl}
                y={-tileOverlap}
                width={edge.width}
                height={tileLength + tileOverlap * 2}
                preserveAspectRatio="none"
                transform={
                  frame.reverseProfile
                    ? `translate(${edge.width} 0) scale(-1 1)`
                    : undefined
                }
              />
            </pattern>
          )
        })}
      </defs>
      {/* Back clipped corners with texture so anti-aliasing cannot expose the page. */}
      <g>
        {edges.map((edge) => (
          <g key={edge.side} transform={edge.transform}>
            <rect
              width={edge.width}
              height={edge.length}
              fill={`url(#${id}-${edge.side}-texture)`}
            />
          </g>
        ))}
      </g>
      {children}
      {edges.map((edge) => (
        <g
          key={edge.side}
          clipPath={`url(#${id}-${edge.side}-clip)`}
        >
          <g transform={edge.transform}>
            <rect
              width={edge.width}
              height={edge.length}
              fill={`url(#${id}-${edge.side}-texture)`}
            />
          </g>
        </g>
      ))}
      {frame.showOutline && (
        <rect
          width={dimensions.outerWidth}
          height={dimensions.outerHeight}
          fill="none"
          stroke="#b0b0b0"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      )}
    </>
  )
}

export default FrameBorder
